export const name = 'obsession';